'use strict';

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// -----------------------------------------------------------
//  OutOfStockMessage
// -----------------------------------------------------------
const OutOfStockMessage = ({ visible, outOfStockInfo }) => {
  if (!visible || !outOfStockInfo) return null;

  return (
    <div
      className={classNames('oos-alert p-3', {
        [`oos-alert--${outOfStockInfo.alertStyle}`]: outOfStockInfo.alertStyle,
      })}>
      <strong className="oos-alert-heading">
        {outOfStockInfo.alertStyle === 'red'
          ? 'Not Available'
          : `${outOfStockInfo.deliveryOptionTitle} Unavailable`}
      </strong>
      <div
        className="oos-alert-body"
        dangerouslySetInnerHTML={{ __html: outOfStockInfo.message }}
      />
    </div>
  );
};

OutOfStockMessage.propTypes = {
  visible: PropTypes.bool,
  outOfStockInfo: PropTypes.shape({
    offer: PropTypes.object,
    message: PropTypes.string,
    alertStyle: PropTypes.string,
    deliveryOptionTitle: PropTypes.string,
  }),
};

export default OutOfStockMessage;
